import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'safe',
    standalone: false
})
export class SafePipe implements PipeTransform {
    constructor(private sanitizer: DomSanitizer) { }
    public transform(value: any, type: string): SafeHtml {
        switch (type) {
            case 'html':
                value = value.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script\s*>/gi, '');
                return this.sanitizer.bypassSecurityTrustHtml(value);
            default: throw new Error(`Invalid safe type specified: ${type}`);
        }
    }
}
